<template lang="html">
  <div class="cancelReason">
    <div class="item-cells">
      <div
        class="item-cell"
        v-for="(reason, index) in reasons"
        :class="{ active: index === checked }"
        @click="chooseReason(index, reason)"
      >
        <div class="item-cell-bd">{{ reason }}</div>
      </div>
    </div>
    <div class="actions">
      <button @click="confirmCancel">确认</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    params: Object,
    callback: {
      // 点击关闭ion关闭回调
      type: Function
    }
  },
  data() {
    return {
      checked: -1,
      reason: ''
    }
  },
  created() {
    console.log(this.params)
    this.$store.dispatch('getReasons')
  },
  computed: {
    ...mapState(['reasons'])
  },
  methods: {
    chooseReason(i, reason) {
      this.checked = i
      this.reason = reason
      // 埋点
    },
    async confirmCancel() {
      if (this.reason === '') {
        this.$$toast('请选择取消原因')
        return
      }
      const { uid, skey } = await this.$$ensureLogin()
      const res = await this.$store.dispatch('cancelOrder', {
        uid,
        skey,
        vorder_id: this.params.order.orderId,
        cancel_reason: this.reason
      })
      if (res.code === '1') {
        this.$$toast('取消成功')
        this.$store.commit('hideActionSheet')
        this.params.success && this.params.success()
      } else if (res.code === '4') {
        this.$$login()
      } else {
        this.$$toast('取消失败')
      }
      this.callback && this.callback()
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.cancelReason {
  height: 100%;
  // position: relative;
  .selected {
    // color: #ff397e;
    color: #ff5900;
  }
  .item-cells {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: rem(100px);
    overflow-x: hidden;
    overflow-y: auto;
  }
  .actions {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;

    button {
      display: block;
      width: 100%;
      text-align: center;
      line-height: rem(98px);
      color: #fff;
      font-size: rem(36px);
      //   background: #ff397e;
      background: #ff5900;
    }
  }
  .active {
    // color: #ff397e;
    color: #ff5900;
  }
}
</style>
